import { Typography, Box, IconButton } from "@mui/material";
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { useNavigate } from 'react-router-dom';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';


const Header = ({ title, subtitle }) => {
    const navigate = useNavigate()

  return (
    <Box mb="20px">
      <Typography
        variant="h5"
        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
        fontWeight="bold"
        sx={{ mb: "5px" }}
      >
        <IconButton onClick={() => navigate(-1)} sx={{ p: 1 }}>
          <ArrowBackRoundedIcon />
        </IconButton>
        <IconButton onClick={() => navigate(+1)} sx={{ p: 1 }}>
          <ArrowForwardRoundedIcon />
        </IconButton>
        | {title}
      </Typography>
      <Typography
        variant="h6"
        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;
